<div class="d-flex justify-content-between align-items-center">
    <h2>{{title}}</h2>
    <div class="d-flex justify-content-between gap-2 page-btns">
        <ap-button *ngFor="let btn of btnList" [btnType]="btn.type || ''" [icon]="btn.icon || ''"
            [label]="btn.label || ''" (onClick)="onClick(btn.action)"></ap-button>
    </div>
</div>